/* tslint:disable */
/* eslint-disable */
/**
 * Quotes Management API
 * API for managing quotes
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Raisons de désactivation des actions (clés i18n)
 * @export
 * @interface BorrowerDisabledReasons
 */
export interface BorrowerDisabledReasons {
    /**
     * 
     * @type {string}
     * @memberof BorrowerDisabledReasons
     */
    canSendMedicalSurvey?: string;
    /**
     * 
     * @type {string}
     * @memberof BorrowerDisabledReasons
     */
    canSendApprovedAgreement?: string;
    /**
     * 
     * @type {string}
     * @memberof BorrowerDisabledReasons
     */
    canSendSubscriptionRequest?: string;
    /**
     * 
     * @type {string}
     * @memberof BorrowerDisabledReasons
     */
    canGetCertificate?: string;
    /**
     * 
     * @type {string}
     * @memberof BorrowerDisabledReasons
     */
    canSendMedicalForm?: string;
}

/**
 * Check if a given object implements the BorrowerDisabledReasons interface.
 */
export function instanceOfBorrowerDisabledReasons(value: object): value is BorrowerDisabledReasons {
    return true;
}

export function BorrowerDisabledReasonsFromJSON(json: any): BorrowerDisabledReasons {
    return BorrowerDisabledReasonsFromJSONTyped(json, false);
}

export function BorrowerDisabledReasonsFromJSONTyped(json: any, ignoreDiscriminator: boolean): BorrowerDisabledReasons {
    if (json == null) {
        return json;
    }
    return {
        
        'canSendMedicalSurvey': json['canSendMedicalSurvey'] == null ? undefined : json['canSendMedicalSurvey'],
        'canSendApprovedAgreement': json['canSendApprovedAgreement'] == null ? undefined : json['canSendApprovedAgreement'],
        'canSendSubscriptionRequest': json['canSendSubscriptionRequest'] == null ? undefined : json['canSendSubscriptionRequest'],
        'canGetCertificate': json['canGetCertificate'] == null ? undefined : json['canGetCertificate'],
        'canSendMedicalForm': json['canSendMedicalForm'] == null ? undefined : json['canSendMedicalForm'],
    };
}

export function BorrowerDisabledReasonsToJSON(json: any): BorrowerDisabledReasons {
    return BorrowerDisabledReasonsToJSONTyped(json, false);
}

export function BorrowerDisabledReasonsToJSONTyped(value?: BorrowerDisabledReasons | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'canSendMedicalSurvey': value['canSendMedicalSurvey'],
        'canSendApprovedAgreement': value['canSendApprovedAgreement'],
        'canSendSubscriptionRequest': value['canSendSubscriptionRequest'],
        'canGetCertificate': value['canGetCertificate'],
        'canSendMedicalForm': value['canSendMedicalForm'],
    };
}

